var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  /* Null-guarded match (ported from the now-deleted assets/money-format-handler.js,
     which this file duplicated and always executed after — see product-section-1.liquid
     script order). Without the guard, a money_format with no {{...}} placeholder makes
     .match() return null and the bare [1] index throws, taking this file's Shopify.formatMoney
     down with it. */
  var placeholderMatch = formatString.match(placeholderRegex);
  switch(placeholderMatch && placeholderMatch[1]) {
    case 'amount':
      /* No ".00" on whole amounts (2026-09-22): $48, but still $7.95 for shipping. */
      value = formatWithDelimiters(cents, (Number(cents) % 100 === 0) ? 0 : 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, (Number(cents) % 100 === 0) ? 0 : 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
